<template>
    <pc-panel-slider
        v-bind="panelSliderBinder"
        v-on:drag-start="store.setDrag(true)"
        v-on:drag-end="store.setDrag(false)">
        <template v-slot:first>
            <attachment-metadata-component
                v-bind:can-approve-attachment="props.canApproveAttachment"
                v-bind:cpr-admin="props.cprAdmin"
                v-on:update-attachment-status="onUpdateStatus"
                v-on:save-feedback="onSaveFeedback"
                v-on:save-requirement-feedback="onSaveRequirementFeedback"
                v-on:run-ai-analysis="runAIAnalysis"
                v-on:clear-ai-result="clearAIResult" />
        </template>
        <template v-slot:second>
            <attachment-display-component />
        </template>
    </pc-panel-slider>
</template>
<script setup>
    import { ref } from "vue";
    import { responsiveManager } from "Responsive/manager";
    import { useAttachmentViewStore } from "./attachmentViewStore";
    import attachmentDisplayComponent from "./attachmentDisplayComponent.vue";
    import attachmentMetadataComponent from "./attachmentMetadataComponent.vue";

    const emit = defineEmits([
        "update-attachment-status",
        "save-feedback",
        "save-requirement-feedback",
        "run-ai-analysis",
        "clear-ai-result"
    ]);

    // constants
    const MIN_PANEL_WIDTH_PX = 450;

    // props
    const props = defineProps({
        canApproveAttachment: { type: Boolean, required: true },
        cprAdmin: { type: Boolean, required: true }
    });

    const store = useAttachmentViewStore();

    // style
    const panelSliderBinder = ref({
        "no-resize": !store.enableAttachmentAnalysis,
        // Using a ratio of .45 provides space for the left hand menu
        "starting-panel-size": responsiveManager.globalWidth.value * 0.45,
        // Allow right panel to be as user wants as long as
        // we can display a reasonable view of capsules
        "max-panel-size": responsiveManager.globalWidth.value - MIN_PANEL_WIDTH_PX,
        "min-panel-size": MIN_PANEL_WIDTH_PX
    });

    // functions
    function onUpdateStatus(statusUpdateAction) {
        emit("update-attachment-status", statusUpdateAction);
    }

    async function onSaveFeedback(feedback) {
        emit("save-feedback", feedback);
    }
    async function onSaveRequirementFeedback(analysis) {
        emit("save-requirement-feedback", analysis);
    }

    async function runAIAnalysis() {
        emit("run-ai-analysis");
    }
    async function clearAIResult() {
        emit("clear-ai-result");
    }
</script>
